import { StyleConfig } from "@chakra-ui/react";

export const Popover: StyleConfig = {
  baseStyle: {
    content: {
      maxWidth: "92vw",
    },
  },
};
